import React, { useState, Fragment, useEffect } from 'react'
import { useQuery } from 'react-apollo-hooks'
import moment from 'moment'
import styled from 'react-emotion'
import cookie from 'js-cookie'
import * as constants from '../../application/constants'
import { urls, settings } from '../../resources'
import getText from '../strings'
import { ErrorMessageBox } from '../../application'
import { useBookings } from '../bookingsContext'
import * as Queries from '../recommendedAncillaries/queries'

const ErrorMsg = styled('div')`
  >div {
    margin-top: 0;
    margin-bottom: 0;
  }
`

const BookingNumber = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: right;
  @media (max-width: 992px) {
    margin-top: 10px;
    flex-direction: row;
    span {
      margin: 0 2px;
    }
  }
`

const Button = styled('button')`
  flex-shrink: 0;
  width: auto;
  margin-bottom: 0px;
  margin-left: 20px;
  @media (max-width: 992px) {
    margin-top: 20px;
    margin-left: 0;
    width: 100%;
  }
`


const BookingDetailButton = ({ bookingNumber, booking }) => {
    const [error, setError] = useState(null)
    const [token, setToken] = useState(null)
    const bookingsData = useBookings()
    const isAtcomBooking = booking.bookingSystem && booking.bookingSystem === "ATCOMRES"
    const { loading, data } = isAtcomBooking
        ? { data: { myHolidayToken: { token: null } } }
        : useQuery(Queries.getMyHolidayToken(bookingNumber))

    useEffect(() => {
        if (!loading && data.myHolidayToken && data.myHolidayToken.token) {
            setToken(data.myHolidayToken.token)
        }
    }, [loading, data])

    const getAtcomButton = () => {
        if (booking.isCancelled)
            return null
        const departureDateFormated = moment(booking.departureDate || booking.startDate).format("DD/MM/YYYY")
        //   const departureDateFormated = moment(booking.departureDate).format("DD/MM/YYYY")
        return (
            <form method="post" action={settings.atcomHost + urls.atcomBooking}>
                <input name="bookingReferenceId" type="hidden" value={bookingNumber} />
                <input name="departureDate" type="hidden" value={departureDateFormated} />
                <input name="surname" type="hidden" value={booking.leadPassengerLastName} />
                <Button
                    disabled={booking.isCancelled || bookingsData.redirectingToMyHoliday}
                    className="btn btn-function"
                    type="submit">{getText('buttons', 'toMyHoliday')}
                </Button>
            </form>
        )
    }

    const getTuiButton = () => {
        if (booking.isCancelled)
            return null
        return (
            <Button
                onClick={() => setMyHolidayToken(bookingNumber)}
                disabled={booking.isCancelled || bookingsData.redirectingToMyHoliday}
                className={bookingNumber === bookingsData.redirectingToMyHoliday
                    ? "btn btn-function btn-loading"
                    : "btn btn-function"}>
                {getText('buttons', 'toMyHoliday')}
            </Button>
        )
    }

    const setMyHolidayToken = async () => {
        bookingsData.onRedirectToMyHolidayStart(bookingNumber)
        setError(null)

        if (token) {
            cookie.set(constants.MYHOLIDAY_SESSION_JWT, token)
            const host = /localhost/.test(window.location.href) ? 'http://localhost:3001' : ''

            window.location.href = `${host}${urls.myHoliday}`
        }

        bookingsData.onRedirectToMyHolidayEnd()
    }

    return (<Fragment>
        {error && <ErrorMsg><ErrorMessageBox message={error} isError={true} /></ErrorMsg>}
        <BookingNumber>
            <span>{getText('bookingNumber')}</span>
            <span><strong>{bookingNumber}</strong></span>
        </BookingNumber>
        {isAtcomBooking
            ? getAtcomButton()
            : getTuiButton()
        }
    </Fragment >)
}

export default BookingDetailButton